import { X, Building2, Users, Kanban, CheckSquare, Receipt, FileText, Wrench, Package } from "lucide-react"
import type { MentionEntity } from "@/lib/ag-ui-types"

const ENTITY_ICONS: Record<string, React.ElementType> = {
  Company: Building2,
  Contact: Users,
  Deal: Kanban,
  Task: CheckSquare,
  Invoice: Receipt,
  Quote: FileText,
  ServiceTicket: Wrench,
  Product: Package,
}

const PILL_COLORS: Record<string, string> = {
  Company: "bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400",
  Contact: "bg-emerald-50 text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-400",
  Deal: "bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400",
  Task: "bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400",
  Invoice: "bg-rose-50 text-rose-700 dark:bg-rose-900/20 dark:text-rose-400",
  Quote: "bg-cyan-50 text-cyan-700 dark:bg-cyan-900/20 dark:text-cyan-400",
  ServiceTicket: "bg-orange-50 text-orange-700 dark:bg-orange-900/20 dark:text-orange-400",
  Product: "bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400",
}

interface AiMentionPillProps {
  entity: MentionEntity
  onRemove: () => void
}

export function AiMentionPill({ entity, onRemove }: AiMentionPillProps) {
  const Icon = ENTITY_ICONS[entity.type] || Building2
  const colors = PILL_COLORS[entity.type] || "bg-gray-50 text-gray-700 dark:bg-gray-900/20 dark:text-gray-400"

  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${colors}`}>
      <Icon size={11} />
      <span className="max-w-[120px] truncate">{entity.title}</span>
      <button
        onClick={onRemove}
        className="ml-0.5 rounded-full p-0.5 transition-colors hover:bg-black/10 dark:hover:bg-white/10"
      >
        <X size={10} />
      </button>
    </span>
  )
}
